var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChecklistIcon = function SvgChecklistIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 6.052,
    width: 16.875,
    height: 17.327,
    rx: 1,
    stroke: "#7D80DA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.35 2.818-2.381 3.25h10.927l-2.38-3.25A2 2 0 0 0 14.901 2h-2.939a2 2 0 0 0-1.613.818z",
    stroke: "#7D80DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
export { SvgChecklistIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjYiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjUiIHk9IjYuMDUyIiB3aWR0aD0iMTYuODc1IiBoZWlnaHQ9IjE3LjMyNyIgcng9IjEiIHN0cm9rZT0iIzdEODBEQSIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8cGF0aCBkPSJtMTAuMzUgMi44MTgtMi4zODEgMy4yNWgxMC45MjdsLTIuMzgtMy4yNUEyIDIgMCAwIDAgMTQuOTAxIDJoLTIuOTM5YTIgMiAwIDAgMC0xLjYxMy44MTh6IiBzdHJva2U9IiM3RDgwREEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+Cjwvc3ZnPgo=";